import { FC, useCallback, useMemo, useState } from 'react';
import { FlexBox, useBreakpoint } from '@brg/ui';
import { Lang, TLangObject } from '@brg/api';
import { Input } from '@brg/input';
import { useTranslation } from 'react-i18next';
import { LayoutConst, useModal } from 'core';
import { ModalButtonFilled, ModalButtonHollow, Wrapper } from './styles';
import { JustTable } from '_competition/components/style';
import { ProjectEditPageGridRow } from 'shared/pages/projectEdit/styles';
import { ProjectEditPageGridList } from '_deziiign/books/pages/BookEdit/styles';
import { DefaultButton } from 'shared/pages/teams/styles';
import PlusSvg from 'shared/assets/32/PlusSvg';
import { createDefaultLangObject } from 'shared/components/__ADDONS__/__SAFEAPI__/Defaults';
import SortableList, { SortableItem, SortableKnob } from 'react-easy-sort';
import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import { DottedIcon } from 'shared/icons/DottedIcon';
import setTextByLang from 'shared/helpers/setTextByLang';

/**
 * @param Модалка редактирования dropdown инпутов в админке
 */

export const FormDropdownEdit: FC<{
    field: any,
    parentIdx: number,
    onAdd?: (data: any, parentIdx: number) => void,
}> = ({
    field,
    parentIdx, 
    onAdd, 
}) => {
    const { t, i18n } = useTranslation();
    const modal = useModal();
    const isS = useBreakpoint(LayoutConst.screen.s);
    const [options, setOptions] = useState<TLangObject<'Global'>[]>(field?.inlineVariants || []);

    const disableSubmit = useMemo(
        () => (!options?.length)  
    , [options]);

    const onSetOptionValue = (index: number, value: any) => {
        const option = options[index];
        const newOptions = [...options];
        const newVal = setTextByLang(option, i18n.language, value)

        newOptions[index] = newVal
        setOptions(newOptions)
    }

    const onDeleteOption = (index: number) => {
        const newOptions = [...options];
        newOptions.splice(index, 1);
        setOptions(newOptions)
    }

    const onMoveOption = useCallback((oldIndex: number, newIndex: number) => {
        const newOpt = arrayMoveImmutable(options, oldIndex, newIndex)
        setOptions(newOpt);
    } , [options])

    const onCreateNewOption = () => {
        setOptions([...options, createDefaultLangObject('')])
    }
    
    const onCancel = () => {
        modal.hide()
    }

    return <Wrapper direction={'column'} width={'100%'} justify='left' align='center'>
               <ProjectEditPageGridRow direction='column' directionMobile={'column'}>
                    <ProjectEditPageGridList direction={'column'} directionMobile="column" isTeamEdit >
                        
                                <>
                                    {!!options?.length && (
                                        <JustTable isTeamEdit>
                                            <thead>
                                                <tr>
                                                    <th style={{width: '75%'}}>Значение</th>
                                                    <th style={{width: '25%'}}></th>
                                                </tr>
                                            </thead>
                                            <SortableList as={'tbody'} onSortEnd={onMoveOption}>
                                                {options?.map((option, index) => {
                                                    return (
                                                        <SortableItem key={"dropdown-edit-sortable_" + index}>
                                                            <tr>
                                                                <td style={{width: '100%'}}>
                                                                    <FlexBox direction='row' gx={16}>
                                                                        <SortableKnob>
                                                                            <div style={{cursor: 'grab', backgroundColor: 'transparent' }}>
                                                                                <DottedIcon />
                                                                            </div>
                                                                        </SortableKnob>
                                                                        <Input.Text
                                                                            value={Lang(option, i18n.language)}
                                                                            onChange={(ev: any) => onSetOptionValue(index, ev.target.value )}
                                                                        />
                                                                    </FlexBox>

                                                                </td>
                                                                <td>
                                                                    <DefaultButton wh={131} whMob={107} onClick={() => onDeleteOption(index)}>Удалить</DefaultButton>
                                                                </td>
                                                            </tr>
                                                        </SortableItem>                                      
                                                    )
                                                })}
                                            </SortableList>
                                        </JustTable>
                                    )}
                                </>

                            <FlexBox offsetTop={24} offsetTopMobile={14}>
                                <DefaultButton wh={131} whMob={107} onClick={() => onCreateNewOption()}>
                                    {isS && <PlusSvg /> }
                                    {'Создать'}
                                </DefaultButton>
                            </FlexBox>
                        </ProjectEditPageGridList>
                            
                </ProjectEditPageGridRow>
               <FlexBox width={'100%'} direction='row' gx={24}>
                    <ModalButtonHollow 
                        onClick={onCancel}
                    >
                        {t('subscription.cancel')}
                    </ModalButtonHollow>
                    <ModalButtonFilled 
                        disabled={disableSubmit} 
                        onClick={() => {
                            onAdd && onAdd({
                                ...field, 
                                inlineVariants: options }
                                , parentIdx)
                            modal.hide();
                        }}
                    >
                        {'Сохранить'}
                    </ModalButtonFilled>
               </FlexBox>
        </Wrapper>

};
import { FC, useCallback, useMemo, useState } from 'react';
import { FlexBox, useBreakpoint } from '@brg/ui';
import { Lang, TLangObject } from '@brg/api';
import { Input } from '@brg/input';
import { useTranslation } from 'react-i18next';
import { LayoutConst, useModal } from 'core';
import { ModalButtonFilled, ModalButtonHollow, Wrapper } from './styles';
import { JustTable } from '_competition/components/style';
import { ProjectEditPageGridRow } from 'shared/pages/projectEdit/styles';
import { ProjectEditPageGridList } from '_deziiign/books/pages/BookEdit/styles';
import { DefaultButton } from 'shared/pages/teams/styles';
import PlusSvg from 'shared/assets/32/PlusSvg';
import { createDefaultLangObject } from 'shared/components/__ADDONS__/__SAFEAPI__/Defaults';
import SortableList, { SortableItem, SortableKnob } from 'react-easy-sort';
import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import { DottedIcon } from 'shared/icons/DottedIcon';
import setTextByLang from 'shared/helpers/setTextByLang';

/**
 * @param Модалка редактирования dropdown инпутов в админке
 */

export const FormDropdownEdit: FC<{
    field: any,
    parentIdx: number,
    onAdd?: (data: any, parentIdx: number) => void,
}> = ({
    field,
    parentIdx, 
    onAdd, 
}) => {
    const { t, i18n } = useTranslation();
    const modal = useModal();
    const isS = useBreakpoint(LayoutConst.screen.s);
    const [options, setOptions] = useState<TLangObject<'Global'>[]>(field?.inlineVariants || []);

    const disableSubmit = useMemo(
        () => (!options?.length)  
    , [options]);

    const onSetOptionValue = (index: number, value: any) => {
        const option = options[index];
        const newOptions = [...options];
        const newVal = setTextByLang(option, i18n.language, value)

        newOptions[index] = newVal
        setOptions(newOptions)
    }

    const onDeleteOption = (index: number) => {
        const newOptions = [...options];
        newOptions.splice(index, 1);
        setOptions(newOptions)
    }

    const onMoveOption = useCallback((oldIndex: number, newIndex: number) => {
        const newOpt = arrayMoveImmutable(options, oldIndex, newIndex)
        setOptions(newOpt);
    } , [options])

    const onCreateNewOption = () => {
        setOptions([...options, createDefaultLangObject('')])
    }
    
    const onCancel = () => {
        modal.hide()
    }

    return <Wrapper direction={'column'} width={'100%'} justify='left' align='center'>
               <ProjectEditPageGridRow direction='column' directionMobile={'column'}>
                    <ProjectEditPageGridList direction={'column'} directionMobile="column" isTeamEdit >
                        
                                <>
                                    {!!options?.length && (
                                        <JustTable isTeamEdit>
                                            <thead>
                                                <tr>
                                                    <th style={{width: '75%'}}>Значение</th>
                                                    <th style={{width: '25%'}}></th>
                                                </tr>
                                            </thead>
                                            <SortableList as={'tbody'} onSortEnd={onMoveOption}>
                                                {options?.map((option, index) => {
                                                    return (
                                                        <SortableItem key={"dropdown-edit-sortable_" + index}>
                                                            <tr>
                                                                <td style={{width: '100%'}}>
                                                                    <FlexBox direction='row' gx={16}>
                                                                        <SortableKnob>
                                                                            <div style={{cursor: 'grab', backgroundColor: 'transparent' }}>
                                                                                <DottedIcon />
                                                                            </div>
                                                                        </SortableKnob>
                                                                        <Input.Text
                                                                            value={Lang(option, i18n.language)}
                                                                            onChange={(ev: any) => onSetOptionValue(index, ev.target.value )}
                                                                        />
                                                                    </FlexBox>

                                                                </td>
                                                                <td>
                                                                    <DefaultButton wh={131} whMob={107} onClick={() => onDeleteOption(index)}>Удалить</DefaultButton>
                                                                </td>
                                                            </tr>
                                                        </SortableItem>                                      
                                                    )
                                                })}
                                            </SortableList>
                                        </JustTable>
                                    )}
                                </>

                            <FlexBox offsetTop={24} offsetTopMobile={14}>
                                <DefaultButton wh={131} whMob={107} onClick={() => onCreateNewOption()}>
                                    {isS && <PlusSvg /> }
                                    {'Создать'}
                                </DefaultButton>
                            </FlexBox>
                        </ProjectEditPageGridList>
                            
                </ProjectEditPageGridRow>
               <FlexBox width={'100%'} direction='row' gx={24}>
                    <ModalButtonHollow 
                        onClick={onCancel}
                    >
                        {t('subscription.cancel')}
                    </ModalButtonHollow>
                    <ModalButtonFilled 
                        disabled={disableSubmit} 
                        onClick={() => {
                            onAdd && onAdd({
                                ...field, 
                                inlineVariants: options }
                                , parentIdx)
                            modal.hide();
                        }}
                    >
                        {'Сохранить'}
                    </ModalButtonFilled>
               </FlexBox>
        </Wrapper>

};
